<script setup>
import { toRef, computed } from 'vue';
import { useChannelIcon } from './provider';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

const channelIcon = useChannelIcon(toRef(props, 'inbox'));

// SMC brand: colour the channel glyph by type (WhatsApp green, Telegram blue).
// `!` beats the inherited text-n-slate-* colour applied by parent components.
const channelColorClass = computed(() => {
  const t = props.inbox?.channel_type || props.inbox?.channelType;
  if (t === 'Channel::Whatsapp') return '!text-[#25AF5F]';
  if (t === 'Channel::Telegram') return '!text-[#2EA0DD]';
  return '';
});
</script>

<template>
  <Icon :icon="channelIcon" :class="channelColorClass" />
</template>
